import { Flex, Tag, Typography } from "antd";
import { deleteFilter } from "slices/documentsSlice";
import { useAppDispatch, useAppSelector } from "utilities/hooks";
import { AnimatePresence, motion } from 'framer-motion';

const FilterChips = ({
    fetchData,
}: {
    fetchData: () => void,
}) => {
    const dispatch = useAppDispatch();
    const {
        params,
    } = useAppSelector((state) => state.documents);

    const handleDeleteFilter = (key: string, id: any = null) => {
        dispatch(deleteFilter({ key, id }));
        fetchData();
    };

    const renderFilter = (key: string, object: any) => {
        // Do not render chip for descendants scope; breadcrumbs indicate context
        if (key === 'in_descendants_of') return;
        if (object.value === null || object.value === undefined) return;

        if (object.value instanceof Date || typeof object.value == 'string' || typeof object.value == 'number') {
            let date = object.value;
            if (typeof object.value === 'string') date = new Date(object.value);
            return (
              <motion.div
                key={key}
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ opacity: 0, width: 0, scale: 0 }}
                transition={{ duration: 0.1 }}
                style={{ display: 'inline-block' }}
              >
                  <Tag
                    closeIcon
                    onClose={(e) => {
                        e.preventDefault();
                        handleDeleteFilter(key);
                    }}
                  >
                      <Typography.Text style={{ fontWeight: 'bold' }} type="secondary">
                          {object.label}:
                      </Typography.Text>{' '}
                      {date instanceof Date ? date.toISOString()?.slice(0, 10) : object.value}
                  </Tag>
              </motion.div>
            );
        } else {
            if (object.value === true) {
                return (
                    <motion.div
                      key={key}
                      initial={{ scale: 0.8, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      exit={{ opacity: 0, width: 0, scale: 0 }}
                      transition={{ duration: 0.1 }}
                      style={{ display: 'inline-block' }}
                    >
                        <Tag
                          closeIcon
                          onClose={(e) => {
                              e.preventDefault();
                              handleDeleteFilter(key);
                            }}
                          >
                              <Typography.Text style={{ fontWeight: 'bold' }} type="secondary">
                                  {object.label}:
                              </Typography.Text>{' '}
                              Yes
                          </Tag>
                    </motion.div>
                );
            }
            return object.value.map(function (el: any) {
                if (el.name || el.label) {
                    return (
                      <motion.div
                        key={key + (el.id || el.name)}
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ opacity: 0, width: 0, scale: 0 }}
                        transition={{ duration: 0.1 }}
                        style={{ display: 'inline-block' }}
                      >
                          <Tag
                            closeIcon
                            onClose={(e) => {
                                e.preventDefault();
                                handleDeleteFilter(key, el.id);
                            }}
                          >
                              <Typography.Text style={{ fontWeight: 'bold' }} type="secondary">
                                  {object.label}:
                              </Typography.Text>{' '}
                              {(el.name || el.label)}
                          </Tag>
                      </motion.div>
                    );
                }
            });
        }
    };

    if (!params.filters || Object.keys(params.filters).length === 0 || (Object.keys(params.filters).length === 1 && params.filters.logic)) return <></>;
    return (
      <Flex style={{ marginBottom: '10px', display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
          <AnimatePresence>
              {/* Render logic chip first if present */}
              {'logic' in params.filters && params.filters.logic && Object.keys(params.filters).length > 1 ? (
                <motion.div
                  key={'__logic__'}
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ opacity: 0, width: 0, scale: 0 }}
                  transition={{ duration: 0.1 }}
                  style={{ display: 'inline-block' }}
                >
                    <Tag
                      closeIcon
                      onClose={(e) => {
                          e.preventDefault();
                          handleDeleteFilter('logic');
                      }}
                    >
                        <Typography.Text style={{ fontWeight: 'bold' }} type="secondary">
                            Matching:
                        </Typography.Text>{' '}
                        {params.filters.logic === 'and' ? 'All filters' : 'Any filter'}
                    </Tag>
                </motion.div>
              ) : null}
              {Object.keys(params.filters).map((key) => (
                renderFilter(key, params.filters?.[key])
              ))}
          </AnimatePresence>
      </Flex>
    );
}

export default FilterChips;